// extracted by mini-css-extract-plugin
export default {"container":"cq-z","brandName":"dq-z","productName":"eq-z","productNamePdpEnhancements":"fq-z","breakLongProductName":"gq-z"};